export default {
    egift: 'paid_egift',
    paidSearch: 'paid_search',
    socialLink: 'social_link'
};
